import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, title, testid }) => (
  <div className="flex items-center gap-4" data-testid={testid}>
    <span className="font-editorial italic text-xl text-copper">{index}</span>
    <span className="h-px w-14 bg-copper/60" />
    <span className="text-xs tracking-[0.3em] uppercase font-heading font-medium text-bone/50">
      {title}
    </span>
  </div>
);
